/*

* This file exports a map that maps error codes to error messages.

*/

export const default_error_message: string = "Something went wrong on our end. Please try again.";

export const ErrorMap = new Map<string, string>([
	["invalid_credentials", "Invalid Phone Number / OTP. Please try again."],
	["recaptcha_failed", "Beegru thinks that you are a robot. If you are not, please try again."],
	["invalid_otp", "Invalid OTP. Please try again."],
	["create_user_failed", default_error_message],
	["database_connection_failed", default_error_message],
	["invalid_send_otp_request_body", "Invalid Phone Number / OTP. Please try again."],
	["send_otp_decryption_failed", default_error_message],
	["send_otp_rate_limiting_in_effect", "You have attempted to send too many OTPs. Please try again later."],
	["send_otp_function_failed", default_error_message],
	["send_otp_encryption_failed", default_error_message],
	["get_rlt_encryption_failed", default_error_message],
	["send_otp_sign_up_check_failed", default_error_message],
	["send_otp_database_connection_failed", default_error_message],
	["failed_to_fetch_from_get_rlt", default_error_message],
	["failed_to_fetch_from_send_otp", default_error_message],
	["client_log_creation_failed", default_error_message],
	["client_log_api_database_connection_failed", default_error_message],
	["client_log_analyze_ip_address_and_analyze_user_agent_functions_failed", default_error_message],
	["client_log_analyze_ip_address_function_failed", default_error_message],
	["client_log_analyze_user_agent_function_failed", default_error_message],
	["client_log_invalid_log_request_body", default_error_message],
	["malformed_search_request_body", default_error_message],
	["ip_address_analysis_failed", default_error_message],
	["user_agent_analysis_failed", default_error_message],
	["filter_hash_generation_failed", default_error_message],
	["failed_to_fetch_from_search_cache", default_error_message],
	["failed_to_fetch_from_property_model", default_error_message],
	["failed_to_fetch_from_services_model", default_error_message],
	["failed_to_fetch_from_business_profiles_model", default_error_message],
	["failed_to_fetch_from_users_model", default_error_message],
	["failed_to_fetch_from_posts_model", default_error_message],
	["failed_to_save_search_cache", default_error_message],
	["failed_to_save_search_log", default_error_message],
	["generate_metadata_api_failed", "Failed to generate metadata for a property. Check logs for more details."],
	[
		"generate_metadata_api_database_connection_failed",
		"Failed to connect to the database while generating metadata for a property.",
	],
	["generate_metadata_api_malformed_property_slug", "Invalid / malformed property slug. Please try again."],
]);
